import { isPersonnel, type DirectoryUser } from '@halo/shared';

/**
 * Người đứng trên các bảng THEO NGƯỜI (KPI tuần, đánh giá tuần, báo cáo công việc): tài khoản đang làm
 * việc trong phạm vi nhìn (`visibleUsernames`; null = cả công ty), TRỪ Giám đốc và Người xem
 * (`isPersonnel`) — họ giao việc, chấm điểm hay xem, không phải người bị chấm hay phải báo cáo. Giữ thứ
 * tự của danh bạ.
 */
export function staffInScope(
  users: readonly DirectoryUser[],
  visibleUsernames: readonly string[] | null,
): string[] {
  const visible = visibleUsernames === null ? null : new Set(visibleUsernames);
  return users
    .filter(
      (user) =>
        user.isActive && isPersonnel(user.role) && (visible === null || visible.has(user.username)),
    )
    .map((user) => user.username);
}
